exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#attachmentsRegisterModal .v--modal-box.v--modal{min-height:430px!important;min-width:740px!important}#attachmentsRegisterModal .modal__content{overflow-y:hidden!important}#attachmentsRegisterModal .modal__footer{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-061aff80","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/registers/AttachmentsRegister.vue
// module id = 2069
// module chunks = 0